module.exports = __webpack_public_path__ + "static/media/pagi-combobox-arrow.33c58e4b.svg";